import Glide, { Breakpoints, Controls, Images, Swipe } from '@glidejs/glide/dist/glide.modular.esm';
import { ClinicSearch } from '../components/clinic/ClinicSearch';
import { CustomMap } from '../components/CustomMap';
import loadGoogleMapsApi from '../utils/MapManager';
import { getDir } from '../../common/components/utils/utils';
import { Autocomplete } from '../components/Autocomplete';

function initMap() {
	window.mapQueue.push(() => {
		ClinicSearch.init();

		// eslint-disable-next-line no-unused-vars
		const header = new Autocomplete('[data-type="autocomplete"]', '[data-auto="results-wrapper"]');

		const map = new CustomMap({ locations: markerLocations });
		CustomMap.onMapInit(map);
	});
	loadGoogleMapsApi();
}

function initCountriesSlider() {
	const countrySliders = [...document.querySelectorAll('[data-slider-countries]')];

	countrySliders.forEach((slider) => {
		new Glide(slider, {
			perView: 3,
			gap: 24,
			rewind: false,
			direction: getDir(),
			breakpoints: {
				600: {
					perView: 2,
					gap: 24,
				},
			},
		}).mount({ Controls, Breakpoints, Swipe, Images });
	});
}

export function init() {
	console.info('Initializing `Search`');
	initMap();
	initCountriesSlider();
}
